/**
 * Risman returns the first free slot on an external booking site as
 * `first-appointment-ts` (unix seconds) plus a ready-made label ("امروز", "فردا", ...).
 * When a crawler stops, both freeze: the page then promises "today" for a slot
 * that passed weeks ago. A slot whose time has passed can never be booked, so
 * drop the time and its label and keep the booking link.
 */
export function dropStaleRismanSlotTime<T>(payload: T, nowMs: number = Date.now()): T {
  const destination = (payload as any)?.data?.destination;
  const ts = destination?.['first-appointment-ts'];
  if (typeof ts !== 'number' || ts * 1000 >= nowMs) return payload;

  return {
    ...(payload as any),
    data: {
      ...(payload as any).data,
      destination: {
        ...destination,
        'first-appointment': null,
        'first-appointment-ts': null,
        // lets pageViewEvent report how often the guard fires, so the next crawler
        // stall shows up in our own dashboards instead of in user complaints
        'stale-dropped': true,
      },
    },
  };
}
